export const EMOJI_SQUARES = {
  0: "🟨",
  1: "🟩",
  2: "🟦",
  3: "🟪",
} as const;

export const WORD_SUBMIT_DELAY = 500;
export const INCORRECT_DELAY = 600;
export const END_SCREEN_DELAY = 900;
